import { Component, Input, OnChanges, SimpleChanges, signal } from '@angular/core';

@Component({
  selector: 'app-progressive-image',
  templateUrl: './progressive-image.component.html',
  styleUrl: './progressive-image.component.css',
  standalone: false
})
export class ProgressiveImageComponent implements OnChanges {

  @Input({ required: true }) src = '';
  @Input() thumbSrc?: string;
  @Input() defaultSrc = '';
  @Input() alt = '';

  highResLoaded = signal(false);
  thumbnailSrc = '';

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['src'] || changes['thumbSrc'] || changes['defaultSrc']) {
      this.highResLoaded.set(false);
      this.thumbnailSrc = this.thumbSrc || this.resolveThumbnailPath(this.src);
    }
  }

  onHighResLoad(): void {
    this.highResLoaded.set(true);
  }

  onHighResError(event: Event): void {
    const image = event.target as HTMLImageElement | null;

    if (!image) {
      return;
    }

    if (this.defaultSrc) {
      image.dataset['fallbackApplied'] = 'true';
      image.src = this.defaultSrc;
      return;
    }

    this.highResLoaded.set(true);
  }

  onThumbnailError(event: Event): void {
    const image = event.target as HTMLImageElement | null;

    if (!image) {
      return;
    }

    const thumbFallback = this.resolveThumbnailPath(this.defaultSrc);
    if (thumbFallback) {
      image.src = thumbFallback;
      return;
    }

    this.thumbnailSrc = this.defaultSrc;
  }

  private resolveThumbnailPath(imagePath: string): string {
    if (!imagePath) {
      return '';
    }

    const normalizedPath = imagePath.replace(/\\/g, '/');

    if (normalizedPath.includes('/thumb/')) {
      return normalizedPath;
    }

    if (normalizedPath.includes('assets/images/')) {
      return normalizedPath.replace('assets/images/', 'assets/images/thumb/');
    }

    return normalizedPath;
  }
}
